<template>
  <div class="BSCTagSelect" ref="tagSelect">
    <div
      class="BSCTagSelect-tags"
      :class="[`is-${type}`]"
      @click="showPicker"
      @blur="showSelect = false"
    >
      <BSCTag
        class="BSCTagSelect-tag"
        v-for="tag in newValue"
        :key="tag.item"
        :label="tag.label"
        :type="tagType"
        :deletable="true"
        @click.stop.prevent.native
        @delete="removeOption(tag)"
      />
    </div>
    <div v-if="showSelect" class="BSCTagSelect-select">
      <div
        v-for="option in filteredOptions"
        :key="option.item"
        class="BSCTagSelect-select-option"
        :value="option.value"
        @click="addToValue(option)"
      >
        {{ option.label }}
      </div>
    </div>
  </div>
</template>

<script>
'use strict'

import BSCTag from './BSCTag'

export default {
  name: 'BSCTagSelect',
  inheritAttrs: false,
  components: {
    BSCTag
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    tagType: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: 'normal'
    }
  },
  data() {
    return {
      newValue: this.value,
      showSelect: false
    }
  },
  methods: {
    showPicker() {
      document.addEventListener('click', this.documentClick)
      this.showSelect = true
    },
    hidePicker() {
      document.removeEventListener('click', this.documentClick)
      this.showSelect = false
    },
    togglePicker() {
      this.showSelect ? this.hidePicker() : this.showPicker()
    },
    documentClick(e) {
      this.$nextTick(() => {
        let el = this.$refs.tagSelect
        let target = e.target
        if (el !== target && !el.contains(target)) {
          this.showSelect = false
        }
      })
    },
    addToValue(option) {
      this.$emit('input', [...this.newValue, option])
    },
    removeOption(option) {
      this.$emit(
        'input',
        this.newValue.filter(v => v !== option)
      )
    }
  },
  computed: {
    filteredOptions() {
      return this.options.filter(
        o => !this.newValue.some(v => v.value === o.value)
      )
    }
  },
  watch: {
    value(newValue) {
      this.newValue = newValue
    }
  }
}
</script>
